import React, { useEffect, useState } from "react";
import { API_BASE_URL } from "src/config/apiBase";
import { decryptToken } from "../utils/getToken";
import { toast } from "react-toastify";
import { Copy, Plus, Trash2 } from "lucide-react";

const CrmPartnerPortalPanel = () => {
  const [partners, setPartners] = useState([]);
  const [saving, setSaving] = useState(false);
  const url = API_BASE_URL;
  const token = decryptToken("accessToken") || "";
  const apiBase = url.replace(/\/$/, "");

  useEffect(() => {
    fetch(`${url}/leads/partner-portals`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((r) => (r.ok ? r.json() : null))
      .then((res) => setPartners(res?.partners || []))
      .catch(() => setPartners([]));
  }, [url, token]);

  const save = async () => {
    setSaving(true);
    try {
      const res = await fetch(`${url}/leads/partner-portals`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ partners }),
      });
      if (!res.ok) throw new Error("Save failed");
      const data = await res.json();
      setPartners(data.partners || partners);
      toast.success("Partner portals saved");
    } catch {
      toast.error("Could not save partners");
    } finally {
      setSaving(false);
    }
  };

  const addPartner = () => {
    setPartners((prev) => [
      ...prev,
      {
        id: `partner_${Date.now()}`,
        name: "New partner",
        apiKey: "",
        active: true,
        contactEmail: "",
      },
    ]);
  };

  const copyKey = (key) => {
    navigator.clipboard?.writeText(key);
    toast.info("API key copied");
  };

  return (
    <div className="crm-partner-portal">
      <div className="crm-integrations__head">
        <strong>Partner / reseller portal</strong>
        <button type="button" onClick={addPartner}>
          <Plus size={14} /> Add partner
        </button>
      </div>
      <p className="crm-insights__muted">
        External agents submit leads via API. POST {apiBase}/leads/partner-submit with header{" "}
        <code>X-Partner-Key</code>.
      </p>

      {partners.map((p, index) => (
        <div key={p.id || index} className="crm-workflow__card">
          <div className="crm-platform__stage-row">
            <input
              className="crm-platform__input"
              placeholder="Partner name"
              value={p.name}
              onChange={(e) =>
                setPartners((prev) =>
                  prev.map((x, i) => (i === index ? { ...x, name: e.target.value } : x))
                )
              }
            />
            <label>
              <input
                type="checkbox"
                checked={p.active !== false}
                onChange={(e) =>
                  setPartners((prev) =>
                    prev.map((x, i) => (i === index ? { ...x, active: e.target.checked } : x))
                  )
                }
              />
              Active
            </label>
            <button type="button" onClick={() => setPartners((prev) => prev.filter((_, i) => i !== index))}>
              <Trash2 size={14} />
            </button>
          </div>
          {p.apiKey && (
            <div className="crm-partner-portal__key">
              <code>{p.apiKey}</code>
              <button type="button" onClick={() => copyKey(p.apiKey)}>
                <Copy size={14} />
              </button>
            </div>
          )}
          <p className="crm-insights__muted">
            Public form: <a href={`/crm-partner?key=${encodeURIComponent(p.apiKey || "")}`} target="_blank" rel="noreferrer">Open submit page</a>
          </p>
        </div>
      ))}

      <button type="button" className="crm-platform__save" onClick={save} disabled={saving}>
        {saving ? "Saving…" : "Save partners"}
      </button>
    </div>
  );
};

export default CrmPartnerPortalPanel;
